<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 50px">
        <span>
          显示模式：
          <el-radio-group v-model="labelval" @change="changePage">
            <el-radio-button :label="0">服务类型</el-radio-button>
            <el-radio-button :label="1">服务内容</el-radio-button>
          </el-radio-group>&nbsp;
        </span>
        <el-button type="primary" plain icon="el-icon-plus" @click="addServiceType(0)">新建服务类型</el-button>
        <el-button type="primary" plain icon="el-icon-plus" @click="addServiceType(1)">新建服务内容</el-button>&nbsp;
        <el-input prefix-icon="el-icon-search" :placeholder="labelval === 0 ? '输入服务类型搜索' : '输入服务内容搜索'" v-model="searchKeyword" @blur="blurData" clearable style="width: 300px" ></el-input>
        <el-button type="primary" plain @click="searchData()">查询</el-button>
      </div>
      <div v-if="labelval === 0" style="max-height: calc(100% - 100px);overflow-y: auto">
        <el-table v-if="labelval === 0" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tbdata0"
          border style="width: 100%" highlight-current-row ref="singleTable">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table style="width: 96%;margin: auto"  size="small" border :data="props.row.childArr" :header-cell-style="{backgroundColor: '#e8f0fa', color: '#696969'}">
                <el-table-column prop="typename" label="服务内容" min-width="90" align="center"></el-table-column>
                <el-table-column prop="createtime" label="录入时间" min-width="90" align="center"></el-table-column>
                <el-table-column label="发起服务扩展字段" min-width="140" align="center">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.service_requirements_tag === 1" v-for="(item, index) in scope.row.servicerequirements[0]" :key="index">{{item.key}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="确认服务扩展字段" min-width="140" align="center">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.service_requirements_tag === 1" v-for="(item, index) in scope.row.servicerequirements[1]" :key="index">{{item.key}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="确认服务照片类型" min-width="140" align="center">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.picture_requirements_tag === 1" v-for="(item, index1) in scope.row.picturerequirements" :key="index1">{{item.key}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="160">
                  <template slot-scope="scope">
                    <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editServiceType(scope.row)"></i>
                    <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delServiceType(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="服务类型" min-width="90" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.is_service === 0">{{scope.row.typename}}</span>
              <span v-else>{{getUpTypeName(scope.row.upid)}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="moduletag !== 2" label="上级类型" min-width="90" align="center">
            <template slot-scope="scope">
              <span>{{getUpTypeName(scope.row.upid)}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="moduletag !== 2" label="所属组织" min-width="100" align="center">
            <template slot-scope="scope">
              <span>{{getOnOrg(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务内容数量" width="180" align="center">
            <template slot-scope="scope">
              <strong v-if="scope.row.childArr.length !== 0">{{scope.row.childArr.length}}</strong>
            </template>
          </el-table-column>
          <el-table-column v-if="moduletag !== 2" prop="createtime" label="录入时间" min-width="90" align="center"></el-table-column>
          <el-table-column align="center" label="操作" width="90">
            <template slot-scope="scope">
              <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editServiceType(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delServiceType(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="labelval === 1" style="max-height: calc(100% - 100px);overflow-y: auto">
        <table-data1 :tbdata1="tbdata1" :tableData="tableData" :orgData="orgData" :moduletag="moduletag" @getFatherChange="getFatherChange"></table-data1>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <!--created update-->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="600px" :show-close="true"
      :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{openTitle}}</span></div>
        <div class="line-title"></div>
      </div>
      <add-edit-stype :addEdit="addEditObj" v-model="addEditShow" @updatetype="updatetype"></add-edit-stype>
    </el-dialog>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {querysuppliertype, deletesuppliertype} from '../../api/serviceMark'
import addEditStype from './childComponents/addEditStype'
import TableData1 from './childComponents/tableData1.vue'
export default {
  name: 'serviceType',
  components: {TableData1, addEditStype},
  data () {
    return {
      moduletag: 0,
      labelval: 0,
      searchKeyword: '',
      orgData: [],
      tableData: [],
      tableData0: [],
      tableData1: [],
      tbdata0: [],
      tbdata1: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      openTitle: '',
      addEditShow: false,
      addEditObj: {
        isAdd: true,
        row: {},
        orgData: [],
        types: [],
        isService: 0
      }
    }
  },
  created () {
    console.log(9999)
    this.moduletag = this.$store.state.user.moduletag
    if (this.moduletag === 2) {
      this.labelval = 0
    }
    this.getOrgData()
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // 组织
    getOrgData () {
      this.loading = true
      queryorg().then(res => {
        this.orgData = res.data.org
        this.addEditObj.orgData = this.orgData
        this.querySupplierTypeData()
      }).catch(() => {
        this.loading = false
      })
    },
    updatetype () {
      this.querySupplierTypeData()
    },
    // 表格
    querySupplierTypeData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.loading = false
        // this.tableData = res.data.types
        let arr = []
        for (let i = 0; i < res.data.types.length; i++) {
          let obj = res.data.types[i]
          obj.servicerequirements = []
          obj.picturerequirements = []
          if (obj.service_requirements_tag === 1) {
            try {
              obj.servicerequirements = JSON.parse(obj.service_requirements)
            } catch (error) {
            }
          }
          if (obj.picture_requirements_tag === 1) {
            try {
              obj.picturerequirements = JSON.parse(obj.picture_requirements)
            } catch (error) {
            }
          }
          arr.push(obj)
        }
        this.tableData = arr
        this.addEditObj.types = res.data.types
        this.endTableData()
      }).catch(() => {
        this.loading = false
      })
    },
    endTableData () {
      this.currentPage = 1
      this.tableData0 = []
      this.tableData1 = []
      this.tbdata0 = []
      this.tbdata1 = []
      for (let i = 0; i < this.tableData.length; i++) {
        let obj = this.tableData[i]
        if (this.tableData[i].is_service === 1) {
          this.tableData1.push(obj)
        } else {
          obj.childArr = []
          this.tableData0.push(this.tableData[i])
        }
      }
      for (let i = 0; i < this.tableData0.length; i++) {
        this.tableData0[i].childArr = this.serviceContentArr(this.tableData0[i].id)
      }
      if (this.labelval === 0) {
        this.searchFilterWord0()
      } else {
        this.searchFilterWord1()
      }
    },
    serviceContentArr (id) {
      let arr = []
      for (let i = 0; i < this.tableData1.length; i++) {
        if (this.tableData1[i].upid === id) {
          arr.push(this.tableData1[i])
        }
      }
      return arr
    },
    // 切换页面展示
    changePage () {
      this.totalCells = 0
      this.pageSize = 10
      this.currentPage = 1
      this.tbdata0 = []
      this.tbdata1 = []
      // this.$forceUpdate()
      if (this.labelval === 0) {
        this.searchFilterWord0()
      } else {
        this.searchFilterWord1()
      }
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.tableData.length; j++) {
          if (parseInt(upids[i]) === this.tableData[j].id) {
            name = this.tableData[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.tableData.length; i++) {
        if (parseInt(upid) === this.tableData[i].id) {
          arr = this.getOrgName1(this.tableData[i].upid, arr)
        }
      }
      return arr
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    blurData () {
      if (this.searchKeyword === '') {
        this.searchData()
      }
    },
    searchData () {
      if (this.labelval === 0) {
        this.searchFilterWord0()
      } else {
        this.searchFilterWord1()
      }
    },
    // table数据入口（tbdata）
    searchFilterWord0 () {
      let data = this.tableData0
      const vm = this
      const search = data.filter((val) => {
        if (val.typename.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      this.tbdata0 = arr
    },
    searchFilterWord1 () {
      let data = this.tableData1
      const vm = this
      const search = data.filter((val) => {
        if (val.typename.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      this.tbdata1 = arr
    },
    // 新建服务类型
    addServiceType (val) {
      if (val === 0) {
        this.openTitle = '新建服务类型'
      } else {
        this.openTitle = '新建服务内容'
      }
      this.addEditObj.isAdd = true
      this.addEditObj.row = {}
      this.addEditObj.isService = val
      this.addEditShow = true
    },
    getFatherChange (obj) {
      if (obj.isEdit) {
        this.editServiceType(obj.row)
      } else {
        this.delServiceType(obj.row)
      }
    },
    // 编辑服务类型
    editServiceType (row) {
      if (row.is_service === 0) {
        this.openTitle = '编辑服务类型'
      } else {
        this.openTitle = '编辑服务内容'
      }
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    // 删除服务类型
    delServiceType (row) {
      let name = row.typename
      this.$confirm('此操作将永久删除该服务类型【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          stids: [row.id]
        }
        deletesuppliertype(data).then(res => {
          if (this.labelval === 0) {
            if (this.tbdata0.length === 1 && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1
            }
          } else {
            if (this.tbdata1.length === 1 && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1
            }
          }
          this.$notify({ title: '成功', message: '删除服务类型成功', type: 'success', duration: 2000 })
          this.querySupplierTypeData()
        }).catch(() => {})
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.labelval === 0) {
        this.searchFilterWord0()
      } else {
        this.searchFilterWord1()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.labelval === 0) {
        this.searchFilterWord0()
      } else {
        this.searchFilterWord1()
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/serviceType.vue